import { defineComponent as _defineComponent } from 'vue'
import { AxiosError } from "axios";
import { ref } from "vue";
import { useRouter } from "vue-router/composables";

import { apiClient } from "@/plugins/api-client";
import { useAuthenticationStore } from "@/stores/authentication";
import { useNotificationStore } from "@/stores/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDeleteDialog',
  props: {
    email: null
  },
  setup(__props: any) {

const { email } = __props as {
  email: string;
}

const router = useRouter();
const notificationStore = useNotificationStore();
const authStore = useAuthenticationStore();



const confirmation = ref<string>("");
const password = ref<string>("");

const isDialogVisible = ref<boolean>(false);

const deleteMe = async () => {
  try {
    await apiClient.userManagement.deleteMe({
      email: confirmation.value,
      password: password.value,
    });
    await authStore.logout();
    notificationStore.addNotification({
      message: "Your Account was deleted successfully.",
      type: "success",
    });
    router.push({ path: "/" });
  } catch (e: unknown) {
    const error = e as AxiosError;
    notificationStore.addNotification({
      message: `Error: ${error.message} ${error?.body?.detail}`,
      type: "error",
    });
  }
};

return { __sfc: true,router, notificationStore, authStore, confirmation, password, isDialogVisible, deleteMe }
}

})